'use strict';

require('../shell/includes.js');
require('./app.js');
require('./controller.js');
require('./bootstrap.js');
